import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditInsurance = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        insurance_company_name: '',
        number_agreement: '',
        date_agreement: '',
        date_start: '',
        date_end: '',
        insurance_premium: '',
        sum_insured: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-insurance?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.insurance_company_name) {
            newErrors.insurance_company_name = 'Обязательное поле';
        }
        if (formInfo.insurance_company_name && (formInfo.insurance_company_name.length < 2 || formInfo.insurance_company_name.length > 200)) {
            newErrors.insurance_company_name = 'Значение не может быть меньше 2 и более 200 символов';
        }

        if (!formInfo.number_agreement) {
            newErrors.number_agreement = 'Обязательное поле';
        }
        if (formInfo.number_agreement && (formInfo.number_agreement.length < 2 || formInfo.number_agreement.length > 20)) {
            newErrors.number_agreement = 'Значение не может быть меньше 2 и более 20 символов';
        }
        if (!formInfo.date_agreement) {
            newErrors.date_agreement = 'Обязательное поле';
        }
        if (!formInfo.date_start) {
            newErrors.date_start = 'Обязательное поле';
        }
        if (!formInfo.date_end) {
            newErrors.date_end = 'Обязательное поле';
        }
        if (!formInfo.insurance_premium) {
            newErrors.insurance_premium = 'Обязательное поле';
        }
        if (formInfo.insurance_premium && (formInfo.insurance_premium.length > 15)) {
            newErrors.insurance_premium = 'Значение не может быть более 15 символов';
        }
        if (!formInfo.sum_insured) {
            newErrors.sum_insured = 'Обязательное поле';
        }
        if (formInfo.sum_insured && (formInfo.sum_insured.length > 15)) {
            newErrors.sum_insured = 'Значение не может быть более 15 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('insurance_company_name', formInfo.insurance_company_name);
        formData.append('number_agreement', formInfo.number_agreement);
        formData.append('date_agreement', normalizeDate(formInfo.date_agreement));
        formData.append('date_start', normalizeDate(formInfo.date_start));
        formData.append('date_end', normalizeDate(formInfo.date_end));
        formData.append('insurance_premium', formInfo.insurance_premium);
        formData.append('sum_insured', formInfo.sum_insured);

        if (files.certificate) {
        formData.append('file_certificate', files.certificate);
        }

        axios.put('/api/add-new-insurance', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-insurance`, {
            id: formInfo.id,
            user_id: formInfo.user_id,
            insurance_company_name: formInfo.insurance_company_name,
            number_agreement: formInfo.number_agreement,
            date_agreement: normalizeDate(formInfo.date_agreement),
            date_start: normalizeDate(formInfo.date_start),
            date_end: normalizeDate(formInfo.date_end),
            insurance_premium: formInfo.insurance_premium,
            sum_insured: formInfo.sum_insured,
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        certificate: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;договора обязательного страхования ответственности
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Наименование страховой компании</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.insurance_company_name} 
                                onChange={handleChange('insurance_company_name')} 
                                className={errorsForm.insurance_company_name ? 'inputError' : ''}
                                placeholder='Полное наименование без сокращений' 
                                minLength='' 
                                maxLength='200' 
                                disabled={loading}
                                required />
                                {errorsForm.insurance_company_name && <div className='errorUnderInput'>{errorsForm.insurance_company_name}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер договора</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.number_agreement} 
                                onChange={handleChange('number_agreement')} 
                                className={errorsForm.number_agreement ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='40' 
                                disabled={loading}
                                required />
                                {errorsForm.number_agreement && <div className='errorUnderInput'>{errorsForm.number_agreement}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата договора</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_agreement?.split('T')[0]}
                                onChange={handleChange('date_agreement')} 
                                className={errorsForm.date_agreement ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_agreement && <div className='errorUnderInput'>{errorsForm.date_agreement}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата начала периода</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_start?.split('T')[0]}
                                onChange={handleChange('date_start')} 
                                className={errorsForm.date_start ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_start && <div className='errorUnderInput'>{errorsForm.date_start}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата окончания периода</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_end?.split('T')[0]}
                                onChange={handleChange('date_end')} 
                                className={errorsForm.date_end ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_end && <div className='errorUnderInput'>{errorsForm.date_end}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Страховая премия</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.insurance_premium} 
                                onChange={handleChange('insurance_premium')} 
                                className={errorsForm.insurance_premium ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='40' 
                                disabled={loading}
                                required />
                                {errorsForm.insurance_premium && <div className='errorUnderInput'>{errorsForm.insurance_premium}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Страховая сумма</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.sum_insured} 
                                onChange={handleChange('sum_insured')} 
                                className={errorsForm.sum_insured ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='40' 
                                disabled={loading}
                                required />
                                {errorsForm.sum_insured && <div className='errorUnderInput'>{errorsForm.sum_insured}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Скан договора</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить договор'
                                        file={files.certificate}
                                        buttonLabel='Прикрепить скан'
                                        onChange={handleFileChange('certificate')}
                                        onReset={handleFileReset('certificate')}
                                    />
                                    {errorsForm.certificate && <div className='errorUnderInput'>{errorsForm.certificate}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditInsurance;